var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApplications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5454 1.66669H5.4545C3.36252 1.66669 1.66663 3.36258 1.66663 5.45457V11.5152C1.66663 13.6072 3.36252 15.3031 5.4545 15.3031H14.5454C16.6374 15.3031 18.3333 13.6072 18.3333 11.5152V5.45457C18.3333 3.36258 16.6374 1.66669 14.5454 1.66669Z",
    fill: "#667085"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.303 16.8182H4.69691C4.49599 16.8182 4.30329 16.898 4.16122 17.0401C4.01915 17.1821 3.93933 17.3748 3.93933 17.5758C3.93933 17.7767 4.01915 17.9694 4.16122 18.1114C4.30329 18.2535 4.49599 18.3333 4.69691 18.3333H15.303C15.5039 18.3333 15.6966 18.2535 15.8387 18.1114C15.9807 17.9694 16.0605 17.7767 16.0605 17.5758C16.0605 17.3748 15.9807 17.1821 15.8387 17.0401C15.6966 16.898 15.5039 16.8182 15.303 16.8182Z",
    fill: "#8F8C9D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplications);
export default __webpack_public_path__ + "static/media/applications.f54703c5c5b47b7c4f18a17774cd9d00.svg";
export { ForwardRef as ReactComponent };